import Multiselect from "multiselect-react-dropdown";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

export default function MultiSelector({
  multiselectRefTracker,
  setSelectCampus,
  setCampusDropDown,
  handleMultiSelectRemove,
  Campus_list_By_Course,
  PreSeSelectedCampuses,
  setPreSeSelectedCampuses,
}) {
  const { Campus_Lists } = useSelector((state) => state.CAMPUS_LIST_REDUCER);

  let MultiSelectorOptions = useCallback(() => {
    let arr = [];
    for (let i = 0; i < Campus_list_By_Course?.length; i++) {
      for (let j = 0; j < Campus_Lists?.length; j++) {
        if (Campus_Lists[j].Campus_Id == Campus_list_By_Course[i].Campus_Id) {
          arr.push(Campus_Lists[j]);
        }
      }
    }
    return arr;
  }, [Campus_list_By_Course, Campus_Lists]);

  useEffect(() => {
    let campus_data = MultiSelectorOptions();
    setPreSeSelectedCampuses(campus_data);
  }, [
    Campus_list_By_Course,
    Campus_Lists,
    MultiSelectorOptions,
    setPreSeSelectedCampuses,
  ]);

  return (
    <Multiselect
      options={Campus_Lists}
      placeholder="Select Campuses"
      displayValue="Campus_Name"
      onSelect={(e) => {
        setCampusDropDown(true);
        setSelectCampus(e);
      }}
      ref={multiselectRefTracker}
      onRemove={(e) => {
        setCampusDropDown(true);
        handleMultiSelectRemove(e);
      }}
      showCheckbox={true}
      selectedValues={PreSeSelectedCampuses}
    />
  );
}
